var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditItems = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3856a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.4998 10.1-3.7-3.70001 2-2c.8-.8 2-.8 2.8 0l.8.8c.8.8.8 2 0 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.5 10.1-10.8 10.9h-3.7v-3.7l10.9-10.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditItems);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-items.3b8b7341eded03a1f0b3cd1bc283274c.svg";